<template>
    <div class="graph" ref="bar">
        <div class="line" v-for="(line, date) in chartData[0]" :data-key="date" @mouseover="current = date">

        </div>
    </div>
</template>

<script>
import http from 'axios';
import anime from 'animejs';
export default {
    data() {
        return {
            feeds: [
                'users/root/calendar.json'
            ],
            chartData: [],
            chart: null,
            current: null
        }
    },
    created() {
        this.feeds.forEach(async url => {
            const result = await http.get(url);
            this.chartData.push(result.data);
        })
    },
    mounted() {
    },
    computed: {
        max() {
            const maxFunc = (max, current) => current > max ? current : max;
            return Object.values(this.chartData[0]).reduce(maxFunc, 0);
        },
        width() {
            if (this._isMounted) {
                return this.$refs.bar.getBoundingClientRect().width;
            } else {
                return 0;
            }
        },
        /*height() {
            if (this._isMounted) {
                return this.$refs.bar.getBoundingClientRect().height;
            } else {
                return 0;
            }
        }*/
    },
    methods: {
        heightStyle (value) {
            //console.log(Math.log10(value + 1), Math.log10(this.max));
            return `${(Math.log10(value + 1) / Math.log10(this.max)) * 100}%`
        }
    },
    watch: {
        chartData (newValues) {
            this.$nextTick(() => {
                anime({
                    targets: this.$el.querySelectorAll('.line'),
                    height: (el, i) => {
                        return this.heightStyle(this.chartData[0][el.dataset.key]);
                    },
                    easing: [.91,-0.54,.29,1.56],
                    //duration: 1500,
                    delay: (el,i) => i * 10
                });
            });
        }
    }
}
</script>

<style lang="scss">
.graph {
    width: 100%;
    display: flex;
    flex-direction: row;
    transform: skewY($skew-degree);
    overflow: hidden;
    z-index: 2;

    .line {
        background: rgba(white, .6);
        flex: 1 0 auto;
        margin: auto 1px 0;
        height: 0;
        //will-change: transform;
        transition: min-width 100ms ease, background 100ms ease;
        min-width: 2px;
        //transform: skewY(-$skew-degree) translateY(20px);
        &:hover {
            min-width: 25px;
            background: rgba(white, .9);
            //transform: scaleX(2);
        }
    }
}
</style>
